import React from "react";
import "./PromoSlider.css";

export default function PromoSilder() {
  return (
    <div className="ib-clients-page">
      {/* Page Title + Breadcrumb */}
      <div className="page-header">
        <h2>Promo Slider List</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / View All
        </div>
      </div>

      {/* Card Container */}
      <div className="card">
        <h3>View all sliders</h3>

        {/* Table Controls */}
        <div className="table-controls">
          <div className="entries">
            <label>
              Show
              <select>
                <option>10</option>
                <option>25</option>
                <option>50</option>
              </select>
              entries
            </label>
          </div>

          <div className="buttons">
            <button>Copy</button>
            <button>CSV</button>
            <button>Excel</button>
            <button>PDF</button>
            <button>Print</button>
            <button className="dropdown">Column visibility ▾</button>
          </div>

          <div className="search">
            <label>
              Search: <input type="text" />
            </label>
          </div>
        </div>

        {/* Table */}
        <table className="ib-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Details</th>
              <th>Status</th>
              <th>Featured</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" className="no-data">
                No data available in table
              </td>
            </tr>
          </tbody>
        </table>

        {/* Pagination */}
        <div className="table-footer">
          <div>Showing 0 to 0 of 0 entries</div>
          <div className="pagination">
            <button disabled>Previous</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}

